import {
    AccessSegment,
    ColumnMetadata,
    ColumnTypes,
} from "~/components/DataGrid";
import { AssetColumns } from "~/modules/assets/types";
import { AssetTableRowData } from "../types";
import { getMeasureValue } from "~/utils/getMeasureValue";
import { Emdash } from "~/components/Punctuation/Emdash";
import { DataGridNumberPercentChangeComboCell } from "~/components/DataGrid/DataGridNumberPercentChangeComboCell";
import { CatalogMetricSlugs } from "~/modules/catalog/types";

// // // //

export const TOTAL_SUPPLY_TOKEN_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.totalSupplyToken,
    label: "Token Supply",
    type: ColumnTypes.number,
    sortsOn: AssetColumns.totalSupplyToken,
    tooltip: CatalogMetricSlugs.total_supply_token,
    width: 200,
    render: (item) => {
        const measure = getMeasureValue(item, "total_supply_token");

        if (measure === null) {
            return <Emdash />;
        }

        return (
            <DataGridNumberPercentChangeComboCell
                value={measure.val}
                pct_change_interval="30d"
                pct_change_value={measure.chg_30d_pct}
                significantDigits={2}
            />
        );
    },
};

export const CIRCULATING_SUPPLY_TOKEN_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.circulatingSupplyToken,
    label: "Circulating Supply",
    type: ColumnTypes.number,
    sortsOn: AssetColumns.circulatingSupplyToken,
    tooltip: CatalogMetricSlugs.circulating_supply_token,
    width: 200,
    access: {
        view: AccessSegment.Preview,
        sort: AccessSegment.Preview,
    },
    render: (item) => {
        const measure = getMeasureValue(item, "circulating_supply_token");

        if (measure === null) {
            return <Emdash />;
        }

        return (
            <DataGridNumberPercentChangeComboCell
                value={measure.val}
                pct_change_interval="30d"
                pct_change_value={measure.chg_30d_pct}
                significantDigits={2}
            />
        );
    },
};

export const BRIDGED_TOKEN_SUPPLY_TOKEN_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.bridgedTokenSupplyToken,
    label: "Bridged Supply",
    tooltip: CatalogMetricSlugs.bridged_token_supply_token,
    type: ColumnTypes.number,
    sortsOn: AssetColumns.bridgedTokenSupplyToken,
    width: 200,
    access: {
        view: AccessSegment.Preview,
        sort: AccessSegment.Preview,
    },
    render: (item) => {
        const measure = getMeasureValue(item, "bridged_token_supply_token");

        if (measure === null) {
            return <Emdash />;
        }

        return (
            <DataGridNumberPercentChangeComboCell
                value={measure.val}
                pct_change_interval="30d"
                pct_change_value={measure.chg_30d_pct}
                significantDigits={2}
            />
        );
    },
};
